import type { APIRequestPathParams, APIResponse } from './base-fetch';
import { get } from './base-fetch';

export type ValidateCommentLinkParams =
  APIRequestPathParams<'/api/v4/comments/validate-link/{linkId}'>;

export type ValidateCommentLinkResponse =
  APIResponse<'/api/v4/comments/validate-link/{linkId}'>;

export const validateCommentLink = ({
  linkId,
}: ValidateCommentLinkParams): Promise<ValidateCommentLinkResponse> =>
  get<ValidateCommentLinkResponse>(`/v4/comments/validate-link/${linkId}`);
